import { AreaWorkstation } from '@/types/area'
import styles from './WorkstationItem.module.scss'
import { Score } from '@/components/Score'
import ChevronRightIcon from '../../../assets/chevron-right.svg'
import { useAreaStore } from '@/modules/Areas'
import { Link } from 'react-router-dom'
import { ROUTES } from '@/router'
import { useWorkstationSelect } from '@/modules/Workstation/hooks/useWorkstationSelect'
import { ModalTypes, useModal } from '@/components/Modal'

export const WorkstationItem = ({ workstation }: { workstation: AreaWorkstation }) => {
    const { openModal } = useModal()
    const { selectedAreaCode } = useAreaStore()
    const { handleWorkstationChange } = useWorkstationSelect()
    const filteredRoutes =
        selectedAreaCode === 'night'
            ? workstation.routes.filter((route) => route.dayType === 'Night')
            : workstation.routes

    const handleOpenRouteDetails = (route: string) => {
        openModal(ModalTypes.routeDetailsModal, { route, workstationNumber: workstation.number })
    }

    return (
        <div className={styles.workstationItem}>
            <div className={styles.header}>
                <Link
                    to={ROUTES.HOME}
                    onClick={() => handleWorkstationChange(workstation.number)}
                    className={styles.titleContainer}
                >
                    <div className={styles.lockContainer}>
                        <span className={styles.title}>{workstation.number}</span>
                    </div>
                    <div className={styles.unfinishedContainer}>
                        {workstation.unfinishedRecordsCount > 0 && (
                            <span className={styles.unfinished}>{workstation.unfinishedRecordsCount} unfinished</span>
                        )}
                        <ChevronRightIcon />
                    </div>
                </Link>
                {workstation.userShift ? (
                    <span className={styles.shift}>
                        {workstation.userShift?.authorName}{' '}
                        <span className={styles.shiftCode}>{workstation.userShift?.dutyCode}</span>
                    </span>
                ) : (
                    workstation.dutyCode && (
                        <span className={styles.shiftCode}>{workstation.dutyCode} not logged in</span>
                    )
                )}
            </div>

            <div className={styles.routesContainer}>
                {filteredRoutes.map((route) => (
                    <div key={route.route} className={styles.route} onClick={() => handleOpenRouteDetails(route.route)}>
                        <div className={styles.chipContainer}>
                            <span className={styles.routeTitle}>{route.route}</span>
                            <Score ewt={route.ewt} mps={route.mps} variance={route.variance} value={+route.ewt} />
                        </div>

                        <span className={styles.strategy}>{route.strategy ?? '-'}</span>
                    </div>
                ))}
            </div>
        </div>
    )
}
